import { useEffect, useState, useCallback } from "react";

export function useSelections<T>(): [T[], (rows: T[]) => void] {
  const [selectedRows, setSelectedRows] = useState<T[]>([]);

  useEffect(() => {
    const handler = (event: Event): void => {
      const customEvent = event as CustomEvent<T[]>;
      setSelectedRows(customEvent.detail);
    };

    window.addEventListener("selectedRowsChanged", handler);

    return () => window.removeEventListener("selectedRowsChanged", handler);
  }, []);

  // Emit function
  const emit = useCallback((rows: T[]) => {
    window.dispatchEvent(new CustomEvent<T[]>("selectedRowsChanged", { detail: rows }));
  }, []);

  return [selectedRows, emit];
}
